
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.944 1.127c-1.712.11-5.116.507-7.217 1.954a.56.56 0 00-.227.463v12.793c0 .406.394.662.727.474 2.162-1.224 5.289-1.558 6.835-1.65.527-.031.938-.507.938-1.078V2.206c0-.622-.48-1.116-1.056-1.08zM8.273 3.08C6.172 1.634 2.768 1.237 1.056 1.127.48 1.09 0 1.584 0 2.207v11.877c0 .57.41 1.047.938 1.078 1.547.091 4.675.425 6.837 1.65.332.188.725-.068.725-.473V3.538a.547.547 0 00-.227-.457z"}})])
          )
        }
      }
    